import styled from 'styled-components';

const Button = styled.button`
  width: 120px;
  padding: 5px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  background-color: #00A859;
  letter-spacing: -0.5px;
  border: none;
  border-radius: 15px;
  margin-top: 20px;
  transition: .2s;
  cursor: pointer;
`;

export {
  Button,
}